import axios from "axios"
import Vue from "vue"
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

const api = axios.create({
	baseURL: process.env.VUE_APP_BASE_URL,
	timeout: 5000,
	headers: {
		'Content-Type': 'application/json',
		'Access-Control-Allow-Origin': process.env.VUE_APP_BASE_URL,
		'X-Requested-With': 'XMLHttpRequest',
	}
})

api.interceptors.request.use((config) => {
	const token = Vue.$cookies.get('authToken')
	if (token) {
		config.headers.Authorization = `Bearer ${token}`
	}
	
	return config
}, (error) => Promise.reject(error))

api.interceptors.response.use((response) => response, (error) => {
	if (error.response && error.response.status === 401) {
		Vue.$cookies.remove('authToken')
        sessionStorage.clear()
		window.location.href = '/landing'
	}

	return Promise.reject(error)
})

export default api;